import React from 'react';
import styled from 'styled-components';
import { SvgWrapper } from '../svg-wrapper';
var Svg = /*#__PURE__*/styled(SvgWrapper).withConfig({
  displayName: "info-icon__Svg",
  componentId: "p70cvz-0"
})(["width:16px;height:16px;color:", ";"], p => p.theme.colors.primary500);
export var Info = (_ref) => {
  var {
    className
  } = _ref;
  return /*#__PURE__*/React.createElement(Svg, {
    viewBox: "0 0 16 16",
    className: className
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4.000000, -4.000000)",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,4 C16.418278,4 20,7.581722 20,12 C20,16.418278 16.418278,20 12,20 C7.581722,20 4,16.418278 4,12 C4,7.581722 7.581722,4 12,4 Z M12,5.2 C8.24615848,5.20408841 5.20408841,8.24615848 5.2,12 C5.2,15.7555363 8.2444637,18.8 12,18.8 C15.7555363,18.8 18.8,15.7555363 18.8,12 C18.8,8.2444637 15.7555363,5.2 12,5.2 L12,5.2 Z M12,10 C12.3865993,10 12.7,10.3134007 12.7,10.7 L12.7,15.7 C12.7,16.0865993 12.3865993,16.4 12,16.4 C11.6134007,16.4 11.3,16.0865993 11.3,15.7 L11.3,10.7 C11.3,10.3134007 11.6134007,10 12,10 Z M12,7.2 C12.5522847,7.2 13,7.64771525 13,8.2 C13,8.75228475 12.5522847,9.2 12,9.2 C11.4477153,9.2 11,8.75228475 11,8.2 C11,7.64771525 11.4477153,7.2 12,7.2 Z"
  })))));
};